<template lang="html">

  <section 
    :class="['pe_grid pe_trivia', {'pe_completed': completed}]"
  >
  
    <transition name="fadeout">
      <div 
        class="pe_blank"
        v-if="!grid.loaded"
      >
        <Spinner type="cube" />
      </div>
    </transition>

    <transition name="fade">
      <div 
        :class="['pe_grid-wrapper',{'pe_loaded': grid.loaded}]"
        v-if="grid.loaded"
        v-show="isPlaying || completed"
      >
        <h3 class="pe_total">
          <span>Total Score: {{ points ? points : 0  }}</span>
          <span>Question: {{ currentRound + 1 }} / {{ triviaData.length }}</span>
        </h3>

        <div name="slide" class="pe_rounds">
          <Round 
            v-for="(data, index) in triviaData"
            v-if="currentRound === index"
            :key="`round_${index}`"
            :question="data.question" 
            :answer="data.answer" 
            :choices="data.choices" 
            :isFinalRound="index === triviaData.length-1"
            @nextRound="onNextRound"
          />
        </div>

      </div>
    </transition>

  </section>

</template>

<script lang="js">

  import { mapActions, mapState, mapGetters } from 'vuex'
  import Spinner from '@puzzleapps/shared/src/components/ui/Spinner'
  import Round from '@puzzleapps/trivia/src/components/Round'
  
  export default  {
    name: 'grid',
    props: ['type'],

    components: {
      Spinner,
      Round,
    },

    data: () => ({
      currentRound: 0,
    }),

    mounted() {
      this.gameInit(this.type)
    },

    destroyed() {
      this.clearPuzzleState()
    },

    methods: {
      ...mapActions({
        gameInit:           'game/init',
        finishGame:         'game/finishGame',
        clearPuzzleState:   'game/clearPuzzleState',
      }),
      
      onNextRound() {
        if (this.currentRound+1 > this.triviaData.length-1)
        {
          return this.finishGame()
        }
        setTimeout(() => this.currentRound++, 1500);
      }

      ///////////////////////////////////////
    },
    
    computed: {
      ...mapState({
        points: state => state.game.points, 
        grid: state => state.grid,
        isPlaying: state => state.game.isPlaying,
        completed: state => state.game.completed,
        gameType: state => state.game.type,
        gameName: state => state.game.name,
        triviaData: state => state.grid.triviaData,
      }),

      ...mapGetters({
        getChoicesWithAnswer: 'grid/getChoicesWithAnswer',
      }),
    }
}


</script>

<style scoped lang="scss">

  @import '@puzzleapps/shared/src/style/variables';

  .pe_grid-wrapper.fade-leave-active,
  .fade-enter-active {
    transition: all 0.5s cubic-bezier(1.0, 0.5, 0.8, 1.0)!important;
  }
  
  .pe_grid-wrapper.fade-leave-to,
  .fade-enter, 
  .slide-fade-leave-to,
  .slide-fadeout-leave-to {
    transition: all 0.5s cubic-bezier(1.0, 0.5, 0.8, 1.0)!important;
    opacity: 0;
  }

  .slide-enter-active {
    transition: all 0.5s cubic-bezier(1.0, 0.5, 0.8, 1.0)!important;
    // transform: rotate(0) translate(10%, 0%)!important;
    // opacity: 1;
  }

  .slide-leave-active {
  }
  
  .slide-leave-to {
    transition: all 0.5s cubic-bezier(1.0, 0.5, 0.8, 1.0)!important;
    transform: rotate(0) translate(-20%, 0%)!important;
    // animation-delay: 0;
    // transition-delay: 0;
    // opacity: 0;
  }
  
  .slide-leave-to,
  .slide-enter {
    opacity: 0;
  }

  .pe_grid {
    max-width: 100%; 
    //margin-top: 2%;   
  }

  .pe_rounds {
    width: 600px;
    position: relative;
    display: flex;
    max-width: 100%;
  }

  .pe_total {
    display: flex;
    justify-content: space-between;
    padding: 0 1em;
    color:#fff!important;
    &span{
      color:#fff;
    }
  }

  .pe_blank {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-image: linear-gradient(135deg, #2957ab, #7f55ff);    
  }

  .pe_spinner {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 50%;

    ::v-deep .cube {
      // width: 85px;
      // height: 85px;
    } 

    ::v-deep .pe_cube > div {
      background: #fff;
      // background-image: linear-gradient(135deg, #2957ab, #7f55ff);
      // border: 2px solid black;
      // width: 20px;
      // height: 20px;
    } 
  }

</style>

